import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    invoices: {
      id: 'pages.invoiceView.breadcrumbs.invoices',
      defaultMessage: 'Invoices',
      description: 'label of the breadcrumb invoices on the invoice view page',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.invoiceView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details tab on the invoice view page',
    },
    items: {
      id: 'pages.invoiceView.subNavigation.items',
      defaultMessage: 'Items',
      description: 'label of the items tab on the order view page',
    },
    logs: {
      id: 'pages.invoiceView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs tab on the order view page',
    },
    communication: {
      id: 'pages.invoiceView.subNavigation.communication',
      defaultMessage: 'Communication',
      description: 'label of the communication tab on the order view page',
    },
  },
  primaryAction: {
    label: {
      id: 'pages.invoiceView.primaryAction.label',
      defaultMessage: 'Edit',
      description: 'label of the primary action on the invoice view page',
    },
  },
  secondaryActions: {
    changePaymentStatus: {
      id: 'pages.invoiceView.secondaryActions.changePaymentStatus',
      defaultMessage: 'Change payment status',
      description: 'label of the secondary action change payment status on the invoice view page',
    },
    generatePdf: {
      id: 'pages.invoiceView.secondaryActions.generatePdf',
      defaultMessage: 'PDF aanmaken',
      description: 'label of the secondary action generate pdf on the invoice view page',
    },
    triggerDataFlow: {
      id: 'pages.invoiceView.secondaryActions.triggerDataFlow',
      defaultMessage: 'Trigger dataflow',
      description: 'label of the secondary action trigger dataflow on the invoice view page',
    },
  },
  changeToDefinitiveDialog: {
    title: {
      id: 'pages.invoiceView.changeToDefinitiveDialog.title',
      defaultMessage: 'Change invoice to definitive',
      description: 'title of the change to definitive confirm dialog on the invoice view page',
    },
    message: {
      id: 'pages.invoiceView.changeToDefinitiveDialog.message',
      defaultMessage:
        "Are you sure you would like to change this invoice to definitive? You can't change this invoice afterwards.",
      description: 'message of the change to definitive confirm dialog on the invoice view page',
    },
    actions: {
      cancel: {
        id: 'pages.invoiceView.changeToDefinitiveDialog.actions.cancel',
        defaultMessage: 'Cancel',
        description:
          'label of the cancel action of the change to definitive confirm dialog on the invoice view page',
      },
      change: {
        id: 'pages.invoiceView.changeToDefinitiveDialog.actions.change',
        defaultMessage: 'Change to definitive',
        description:
          'label of the change action of the change to definitive confirm dialog on the invoice view page',
      },
    },
  },
  generatePdfProgressDialog: {
    message: {
      id: 'pages.invoiceView.generatePdfProgressDialog.message',
      defaultMessage: 'Generating pdf',
      description: 'Generating pdf progress dialog message',
    },
  },
  feedback: {
    invoiceChangedToDefinitive: {
      id: 'pages.invoiceView.feedback.invoiceChangedToDefinitive',
      defaultMessage: 'Invoice changed to definitive',
      description: 'Invoice change definitive success message',
    },
    invoiceNotChangedToDefinitive: {
      id: 'pages.invoiceView.feedback.invoiceNotChangedToDefinitive',
      defaultMessage: 'Invoice could not be changed to definitive',
      description: 'Invoice change definitive error message',
    },
    invoiceGeneratingPdfFailed: {
      id: 'pages.invoiceView.feedback.invoiceGeneratingPdfFailed',
      defaultMessage: 'Invoice PDF could not be generated',
      description: 'Generate pdf action error message',
    },
  },
};

export default defineMessages(translations);
